/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Radio } from 'antd'
import { OUTCOME_CLASS, RADIO_GROUP_CLASS, TypeProps } from '../OutcomeBlockNew'

/**
 * 핸디캡, 언더오버 등 기준점이 존재하는 마켓에 주로 사용
 * 테이블 상단 컬럼: 아웃컴 이름 (ex. 첼시, 리버풀)
 * 테이블 좌측 컬럼: 기준점 (ex. -1.5, 0.5)
 *
 * @param {TypeProps} props
 */
const Type2: React.FC<TypeProps> = (props: TypeProps) => {

  const {
    markets,
    initialOutcomeCount,
    renderOutcomeHeader,
    makeOutcomesElement,
    selectedField,
  } = props

  const viewKeyPrefix = 'OutcomeBlockType:Type2:'

  const outcomeHeadOrders = []
  for (let i = 1; i <= initialOutcomeCount; i += 1) {
    outcomeHeadOrders.push(i)
  }

  const renderOutcomes = (market) => {
    const outcomes = []
    for (let i = 1; i <= initialOutcomeCount; i += 1) {
      const outcome = market.outcomes.find(object => object.order === i)
      outcomes.push(outcome)
    }

    const outcomeElements = makeOutcomesElement(market, outcomes)
    return outcomeElements
  }

  return (
    <Fragment>
      <div className={OUTCOME_CLASS.POINT}>
        {renderOutcomeHeader(markets[0], outcomeHeadOrders)}
      </div>

      <div className="outcome-btn-wrap">
        <Radio.Group value={selectedField} className={RADIO_GROUP_CLASS.BTN_2_WAY}>
          {markets.map(market => (
            <div key={`${viewKeyPrefix}_${market.id}_${market.specialBetValue}`} className="btn-group">
              <div className="match-point">{market.specialBetValue}</div>
              {renderOutcomes(market)}
            </div>
          ))}
        </Radio.Group>
      </div>
    </Fragment>
  )
}

export default observer(Type2)
